import { createFileRoute } from '@tanstack/react-router'
import CamposCustomizadosPage from '@/pages/dashboard/campos-customizados-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/campos-customizados',
)({
  component: function CamposCustomizadosRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <CamposCustomizadosPage />
      </ProtectedRoute>
    )
  },
})
